
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/shared/content-migrations/jst/ImportQuizzesNextView';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  
  return "style=\"color: #ccc;\"";
  }

function program3(depth0,data) {
  
  
  return "disabled=true";
  }

function program5(depth0,data) {
  
  
  return "checked";
  }

function program7(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n    "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'w0': ("<b>$1</b>"),
    'i18n_scope': ("content_migrations.subviews.import_quizzes_next_view")
  },data:data},helper ? helper.call(depth0, "content_migrations.subviews.import_quizzes_next_view.import_new_quizzes_all", "Convert content to *New Quizzes*", options) : helperMissing.call(depth0, "t", "content_migrations.subviews.import_quizzes_next_view.import_new_quizzes_all", "Convert content to *New Quizzes*", options)))
    + "\n  ";
  return buffer;
  }

function program9(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n    "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'w0': ("<b>$1</b>"),
    'i18n_scope': ("content_migrations.subviews.import_quizzes_next_view")
  },data:data},helper ? helper.call(depth0, "content_migrations.subviews.import_quizzes_next_view.import_new_quizzes", "Import existing quizzes as *New Quizzes*", options) : helperMissing.call(depth0, "t", "content_migrations.subviews.import_quizzes_next_view.import_new_quizzes", "Import existing quizzes as *New Quizzes*", options)))
    + "\n  ";
  return buffer;
  }

function program11(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n      \""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("content_migrations.subviews.import_quizzes_next_view")
  },data:data},helper ? helper.call(depth0, "content_migrations.subviews.import_quizzes_next_view.convert_to_nq_help_title", "Convert Quizzes", options) : helperMissing.call(depth0, "t", "content_migrations.subviews.import_quizzes_next_view.convert_to_nq_help_title", "Convert Quizzes", options)))
    + "\"\n    ";
  return buffer;
  }

function program13(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n      \""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("content_migrations.subviews.import_quizzes_next_view")
  },data:data},helper ? helper.call(depth0, "content_migrations.subviews.import_quizzes_next_view.import_quizzesNext_help_title", "New Quizzes", options) : helperMissing.call(depth0, "t", "content_migrations.subviews.import_quizzes_next_view.import_quizzesNext_help_title", "New Quizzes", options)))
    + "\"\n    ";
  return buffer;
  }

function program15(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n      ";
  stack1 = (helper = helpers.__i18nliner_safe || (depth0 && depth0.__i18nliner_safe),options={hash:{},data:data},helper ? helper.call(depth0, "<p></p>", options) : helperMissing.call(depth0, "__i18nliner_safe", "<p></p>", options));
  buffer += escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'p_p': (stack1),
    'i18n_scope': ("content_migrations.subviews.import_quizzes_next_view")
  },data:data},helper ? helper.call(depth0, "content_migrations.subviews.import_quizzes_next_view.convert_to_nq_help_text", "Existing question banks and classic quizzes will be imported as Item Banks and New Quizzes.%{p_p}To learn more, please contact your system administrator or visit", options) : helperMissing.call(depth0, "t", "content_migrations.subviews.import_quizzes_next_view.convert_to_nq_help_text", "Existing question banks and classic quizzes will be imported as Item Banks and New Quizzes.%{p_p}To learn more, please contact your system administrator or visit", options)))
    + "\n    ";
  return buffer;
  }

function program17(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n      ";
  stack1 = (helper = helpers.__i18nliner_safe || (depth0 && depth0.__i18nliner_safe),options={hash:{},data:data},helper ? helper.call(depth0, "<p></p>", options) : helperMissing.call(depth0, "__i18nliner_safe", "<p></p>", options));
  buffer += escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'p_p': (stack1),
    'i18n_scope': ("content_migrations.subviews.import_quizzes_next_view")
  },data:data},helper ? helper.call(depth0, "content_migrations.subviews.import_quizzes_next_view.import_new_quizzes_help_text", "New Quizzes is the new assessment engine for Canvas.%{p_p}To learn more, please contact your system administrator or visit", options) : helperMissing.call(depth0, "t", "content_migrations.subviews.import_quizzes_next_view.import_new_quizzes_help_text", "New Quizzes is the new assessment engine for Canvas.%{p_p}To learn more, please contact your system administrator or visit", options)))
    + "\n    ";
  return buffer;
  }

  buffer += "<label class=\"checkbox\" for=\"importQuizzesNext\" ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.quizzesNextEnabled), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += ">\n  <input type=\"checkbox\" id=\"importQuizzesNext\" ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.disableNQMigrationCheckbox), {hash:{},inverse:self.noop,fn:self.program(3, program3, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += " ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.migrationDefault), {hash:{},inverse:self.noop,fn:self.program(5, program5, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "/>\n\n  ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.unattachedBankMigrationsEnabled), {hash:{},inverse:self.program(9, program9, data),fn:self.program(7, program7, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n  <a href=\"#\" class=\"element_toggler\" style=\"margin-left: 10px\" aria-controls=\"import_quizzesNext_helpDialog\" aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("content_migrations.subviews.import_quizzes_next_view")
  },data:data},helper ? helper.call(depth0, "content_migrations.subviews.import_quizzes_next_view.import_quizzesNext_help_label", "Import assessment as New Quizzes Help Icon", options) : helperMissing.call(depth0, "t", "content_migrations.subviews.import_quizzes_next_view.import_quizzesNext_help_label", "Import assessment as New Quizzes Help Icon", options)))
    + "\" title=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("content_migrations.subviews.import_quizzes_next_view")
  },data:data},helper ? helper.call(depth0, "content_migrations.subviews.import_quizzes_next_view.import_quizzesNext_help_title_icon", "Import assessment as New Quizzes Help Icon", options) : helperMissing.call(depth0, "t", "content_migrations.subviews.import_quizzes_next_view.import_quizzesNext_help_title_icon", "Import assessment as New Quizzes Help Icon", options)))
    + "\">\n    <i class=\"icon-question\"></i>\n  </a>\n\n  <div id=\"import_quizzesNext_helpDialog\" data-read-on-open=\"true\" data-turn-into-dialog='{\"width\":600,\"modal\":true}' style=\"display:none\"\n    title=";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.unattachedBankMigrationsEnabled), {hash:{},inverse:self.program(13, program13, data),fn:self.program(11, program11, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  >\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.unattachedBankMigrationsEnabled), {hash:{},inverse:self.program(17, program17, data),fn:self.program(15, program15, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n     <a href=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("community"),
    'i18n_used_in': ("content_migrations.subviews.import_quizzes_next_view")
  },data:data},helper ? helper.call(depth0, "community.instructor_guide", "", options) : helperMissing.call(depth0, "t", "community.instructor_guide", "", options)))
    + "\" target=\"_blank\" rel=\"noopener noreferrer\">Canvas Instructor Guide</a>.\n  </div>\n</label>\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  